import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setWithdrawalScaleOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { randomNumber } from '../../../utilities'
import { IWithdrawalScale, IWithdrawalScaleSection } from '../store/options.types'

export function* getWithdrawScaleOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const withdrawScaleResponse: IOptionsResponse = yield call([vitalsService, vitalsService.getWithdrawalScale])

    if (!withdrawScaleResponse?.entity) {
      return
    }

    const enrichedScales: IWithdrawalScale[] = (withdrawScaleResponse.entity as IWithdrawalScale[]).map(
      (scale: IWithdrawalScale) => ({
        ...scale,
        sections: scale.sections.map((section: IWithdrawalScaleSection) => ({
          ...section,
          fieldId: randomNumber(),
        })),
      })
    )

    yield put(setWithdrawalScaleOptions(enrichedScales))
  } catch (e) {
    yield put(throwPcrException(`getWithdrawScaleOptions() error: ${e}`))
  }
}

export function* getWithdrawScaleOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getWithdrawScaleOptions)
}
